
(function () {
  function updateCollectionReviews() {
    document.querySelectorAll(
      '.collection-yotpo-rating .yotpo-sr-bottom-line-text'
    ).forEach(function (element) {

      if (element.dataset.reviewUpdated) return;

      var match = element.textContent.trim().match(/\d+/);

      if (match) {
        element.textContent = '(' + match[0] + ')';
        element.dataset.reviewUpdated = 'true';
      }
    });
  }

  var count = 0;

  var timer = setInterval(function () {
    updateCollectionReviews();

    count++;

    if (count >= 10) {
      clearInterval(timer);
    }
  }, 500);
})();
